// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  projectId: __t.u64().primaryKey().name("project_id"),
  owner: __t.identity(),
  worldId: __t.u64().name("world_id"),
  sdkVersion: __t.string().name("sdk_version"),
  fidelityTier: __t.u8().name("fidelity_tier"),
  status: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
